import BaseService from "./BaseService";

class UserService {
  static async getUsers(token, params) {
    try {
        if (params) {
          return await BaseService.get("users", '', params);
        }
        return await BaseService.get("users", token);
    } catch (error) {
      console.error("There was an error fetching the users!", error);
      throw error;
    }
  }
  static async postUser(userData, token) {
    try {
      return await BaseService.post("users", userData, token);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async resetPassword(params) {
    try {
      return await BaseService.post("password/reset-password", {}, '', params);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async editUser(id, userData, resetPassword) {
    try {
      if(resetPassword){
        return await BaseService.put("password/reset-password", id, userData, null);
      }
      return await BaseService.put("users", id, userData);
    } catch (error) {
      console.error("There was an error editing the user!", error);
      throw error;
    }
  }

  static async deleteUser(Id, token) {
    try {
      return await BaseService.delete("users", Id, token);
    } catch (error) {
      console.error("There was an error deleting the user!", error);
      throw error;
    }
  }
}

export default UserService;